import PhoneInput from 'react-phone-input-2';
import { techTheme } from 'src/features/common/app/components/theme-provider/theme';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import styled, { css } from 'styled-components';

interface Props {
    withGap?: boolean;
}

export const AddressTitle = styled(Typography)`
    font-size: 18px;
    font-weight: 500;
    padding: 24px 0;
`;
export const StyledPhoneInput = styled(PhoneInput)`
    .input-styles {
        height: 48px;
        font-family: ${({ theme }) => theme.fonts.text};
        font-weight: 400;
        font-size: 16px;
        color: ${({ theme }) => theme.colors.gs100};
        border: 1px solid ${techTheme.colors.grey800};
        background: ${({ theme }) => theme.colors.grey800};
        border-radius: 8px;
        width: 100%;

        &:disabled {
            border-color: ${techTheme.colors.gs450};
            color: ${techTheme.colors.grey400};
        }

        ::-webkit-input-placeholder {
            color: ${({ theme }) => theme.colors.gs100};
        }

        ::-webkit-outer-spin-button,
        ::-webkit-inner-spin-button,
        &[type='number'] {
            -webkit-appearance: none;
            margin: 0;
        }

        &:hover {
            border-color: ${techTheme.colors.gs450};
        }

        &:focus {
            outline: none;
            border: 1px solid ${techTheme.colors.gs450};
            background: ${({ theme }) => theme.colors.grey800};
        }

        &::placeholder {
            color: ${techTheme.colors.gs100};
        }
    }

    .country-list {
        background: ${({ theme }) => theme.colors.grey800};
    }

    .country-list li.country:hover {
        background: rgba(255, 255, 255, 0.06);
    }

    .country-list .country.highlight {
        background: rgba(255, 255, 255, 0.06);
    }

    .country-list .country {
        font-family: ${({ theme }) => theme.fonts.text};
    }

    .dropdown-styles .selected-flag:focus:before,
    .dropdown-styles .selected-flag.open:before {
        border: none;
        box-shadow: none;
    }
`;

const columnMixin = css<Props>`
    gap: 16px;
    margin-bottom: ${({ withGap }) => withGap && '24px'};

    > div {
        flex: 1;

        input {
            width: 100%;
        }
    }
`;

export const StyledColumns = styled(FlexBox)<Props>`
    ${columnMixin}
`;

export const StyledFormTypeWrapper = styled.div<{ type: 'shipping' | 'billing'; stepper?: boolean }>`
    margin-top: ${({ type, stepper }: any) => (stepper && type === 'billing' ? '-40px' : '0')};
`;